import { MethodsService } from '../../methods/methods.service'

export class PiReportsProcessorService {
  static processMetadata (data: PiExtendedReportMetadata[]): PiExtendedReportMetadata[] {

    return data.map(report => {
      report._name = `${MethodsService.normalizeString(report.type)}`
      return report
    }) as PiExtendedReportMetadata[]

  }

  static process<T extends StandardJson> (data: T[]): T[] {
    if (!data?.length) {
      return data
    }

    //rebuild the 'data' object so string key types will occur first, then number key types, then a second sort key by alphabetical order
    const stringKeys = Object.keys(data[0]).filter(key => typeof data[0][key] === 'string').sort()
    const booleanKeys = Object.keys(data[0]).filter(key => typeof data[0][key] === 'boolean').sort()
    const numberKeys = Object.keys(data[0]).filter(key => typeof data[0][key] === 'number').sort()
    const allKeys = [...stringKeys, ...booleanKeys, ...numberKeys]

    data = data.map(item => {
      const newItem: StandardJson = {}
      allKeys.forEach(key => {
        newItem[key] = item[key]
      })
      return newItem
    }) as T[]

    return data
  }

}
